var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.728,
    height: 21.728
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a3f6e",
    d: "M10.866 0a10.864 10.864 0 1010.862 10.866A10.864 10.864 0 0010.866 0zm0 3.25a3.593 3.593 0 11-3.594 3.593 3.593 3.593 0 013.594-3.593zm5.188 13.725a8 8 0 01-10.385 0 1.535 1.535 0 01-.535-1.164 3.621 3.621 0 013.641-3.622h4.18a3.617 3.617 0 013.636 3.622 1.524 1.524 0 01-.538 1.164z"
  })));
}

export default SvgPerson;